// Developer memo:
// - AI competition model colors must be deterministic by model label.
// - Do not rely on Chart.js default colors or dataset index for AI competition.
// - Keep Qwen, Deepseek, Gemini, GPT, Claude, and Grok visually distinct on the purple data page background.

export function fallbackBorderColor(index) {
    return `rgba(${index * 50 % 255}, ${index * 100 % 255}, ${index * 150 % 255}, 1)`;
}

export function fallbackBackgroundColor(index) {
    return `rgba(${index * 50 % 255}, ${index * 100 % 255}, ${index * 150 % 255}, 0.2)`;
}

const AI_MODEL_COLORS = [
    { pattern: /deepseek/i, color: 'rgba(16, 185, 129, 1)' },
    { pattern: /gpt/i, color: 'rgba(255, 77, 109, 1)' },
    { pattern: /claude/i, color: 'rgba(55, 65, 81, 1)' },
    { pattern: /grok/i, color: 'rgba(139, 92, 246, 1)' },
    { pattern: /qwen/i, color: 'rgba(245, 158, 11, 1)' },
    { pattern: /gemini/i, color: 'rgba(59, 130, 246, 1)' },
];

function isLowContrastColor(color) {
    if (!color) return true;
    const normalized = String(color).trim().toLowerCase();
    if (normalized === '#fff' || normalized === '#ffffff' || normalized === 'white') return true;
    const match = normalized.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (!match) return false;
    const red = Number(match[1]);
    const green = Number(match[2]);
    const blue = Number(match[3]);
    return red >= 190 && green >= 190 && blue >= 190;
}

export function aiModelColor(label, index, currentColor) {
    if (!isLowContrastColor(currentColor)) return currentColor;
    const match = AI_MODEL_COLORS.find((item) => item.pattern.test(label || ''));
    return match ? match.color : fallbackBorderColor(index);
}
